////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

// BoredAndAmbitious_Home_SRC_Main.tsx
// Main entry point for Bored & Ambitious Homepage

/*
═══════════════════════════════════════════════════════════════════════════════════════
  IMPORTS - Third Party
═══════════════════════════════════════════════════════════════════════════════════════
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';

/*
═══════════════════════════════════════════════════════════════════════════════════════
  IMPORTS - First Party
═══════════════════════════════════════════════════════════════════════════════════════
*/

import { HomepageLobbyPod } from '../homepage/lobby/pod/BoredAndAmbitious_Home_SRC_Homepage_Lobby_Pod.js';

/*
═══════════════════════════════════════════════════════════════════════════════════════
  GLOBAL STYLES
═══════════════════════════════════════════════════════════════════════════════════════
*/

const globalStyles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: #0a0a0a;
    color: #f5f5f5;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.6;
    min-height: 100vh;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    background: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Playfair Display', Georgia, serif;
    font-weight: 600;
    line-height: 1.2;
  }

  /* Gold gradient text utility */
  .gold-text {
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 25%, #FFD700 50%, #FF8C00 75%, #FFD700 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  /* Glow effect utility */
  .gold-glow {
    text-shadow: 0 0 20px rgba(255, 215, 0, 0.3);
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #0a0a0a;
  }

  ::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #444;
  }

  /* Selection styling */
  ::selection {
    background: rgba(255, 215, 0, 0.3);
    color: #fff;
  }
`;

/*
═══════════════════════════════════════════════════════════════════════════════════════
  APP COMPONENT
═══════════════════════════════════════════════════════════════════════════════════════
*/

function App(): React.ReactElement {
  return (
    <>
      <style>{globalStyles}</style>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomepageLobbyPod />} />
          <Route path="*" element={<HomepageLobbyPod />} />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </>
  );
}

/*
═══════════════════════════════════════════════════════════════════════════════════════
  MOUNT APPLICATION
═══════════════════════════════════════════════════════════════════════════════════════
*/

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
